import { getApiBaseUrl } from '../../../config/app-config';
import { verifyAuth, getAuthToken } from '../../auth';

/**
 * Проверяет, авторизован ли текущий пользователь как админ
 * @returns {Promise<Object|null>} Объект с данными пользователя или null
 */
export async function checkAdminAuth() {
    const token = getAuthToken();
    if (!token) {
        return null;
    }

    try {
        // Инициируем проверку токена
        const userData = await verifyAuth(token);
        return userData;
    } catch (error) {
        console.error('[AdminAuth] Authorization error:', error);
        localStorage.removeItem('token');
        return null;
    }
}

/**
 * Выполняет проверку валидности токена с сервером
 * @param {string} token JWT токен
 * @returns {Promise<Object>} Данные авторизованного пользователя
 */
export async function validateAdminToken(token) {
    if (!token) {
        return Promise.reject(new Error('No token provided'));
    }

    let apiUrl;
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        apiUrl = 'http://127.0.0.1:8001';
    } else {
        apiUrl = window.location.origin;
    }

    try {
        const response = await fetch(`${apiUrl}/api/admin/me`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (!response.ok) {
            throw new Error('Invalid token');
        }

        return await response.json();
    } catch (error) {
        console.error('[AdminAuth] Token validation failed:', error);
        throw error;
    }
}

/**
 * Выполняет выход из админ-панели
 */
export function logoutAdmin() {
    localStorage.removeItem('token');
    window.location.reload();
}